import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { ColorPicker } from '../shared/ColorPicker';
const RING = '#000000';
// Sketch colour: the preset swatches (black selection ring so the active one
// reads clearly on the light card), plus a "used in this project" row when
// there are project colours that aren't already in the presets. Kept simple
// on purpose — no custom hex chooser.
export const SketchColorPicker = ({ selectedColor, onColorChange, projectColors = [], }) => {
    const projectOptions = projectColors.map(c => ({ color: c, name: c }));
    return (_jsxs("div", { className: "flex flex-col gap-2", children: [_jsx(ColorPicker, { selectedColor: selectedColor, onColorChange: onColorChange, ringColor: RING }), projectOptions.length > 0 && (_jsxs("div", { children: [_jsx("div", { className: "text-[10px] uppercase tracking-wide mb-1 px-1", style: { color: 'var(--pewter)' }, children: "Used in this project" }), _jsx(ColorPicker, { selectedColor: selectedColor, onColorChange: onColorChange, colors: projectOptions, ringColor: RING })] }))] }));
};
